import { Card, CardBody } from '@/common'
import { LoopIcon } from '@/common/components/icons'
import { useTranslation } from 'react-i18next'
import InputsReporting from './InputsReporting'
import { ReportSectionCardHeader } from '../SectionCardHeader'

export default function InputsSection({
  isApplicableForActivityLevelValidation,
  emissionReportId,
  methodEmissionReportId,
  isViewMode,
  emissions,
  installationId,
  reportStartDate,
  reportEndDate,
  isComplete
}: {
  isComplete: boolean
  isApplicableForActivityLevelValidation: boolean
  emissionReportId: string
  methodEmissionReportId: string
  isViewMode: boolean
  emissions: number
  installationId: string
  reportStartDate: string
  reportEndDate: string
}) {
  const { t } = useTranslation()

  return (
    <div>
      <Card>
        <ReportSectionCardHeader
          icon={<LoopIcon className="size-4" />}
          title={t('report:precursors.title')}
          emissions={emissions}
          completionPercentage={isComplete ? 100 : 0}
        />
        <CardBody>
          <InputsReporting
            emissionReportId={emissionReportId}
            methodEmissionReportId={methodEmissionReportId}
            isViewMode={isViewMode}
            installationId={installationId}
            isApplicableForActivityLevelValidation={isApplicableForActivityLevelValidation}
            reportStartDate={reportStartDate}
            reportEndDate={reportEndDate}
          />
        </CardBody>
      </Card>
    </div>
  )
}
